export default __webpack_public_path__ + "static/curriculum-guide-preview-5-8937d39fa92ff7a9a6bc6bd9d14aad25.jpg";